// D@987825, D@992977 (AE-4): "Oct 7, 2026 at 3:16 PM", in the chamber time zone.
export const formatAutomatedEmailTime = (value?: number | null, timeZone?: string) => {
  if (!value) return "Not saved yet";
  const format = (options: Intl.DateTimeFormatOptions) => {
    // A stored zone that is not an IANA name must never break the page.
    try { return new Intl.DateTimeFormat("en-US", { ...options, ...(timeZone ? { timeZone } : {}) }).format(value); }
    catch { return new Intl.DateTimeFormat("en-US", options).format(value); }
  };
  return `${format({ month: "short", day: "numeric", year: "numeric" })} at ${format({ hour: "numeric", minute: "2-digit" })}`;
};
